export const ProfileTabs = {
  BASIC_INFO: "basic-info",
  MANAGE_ACCOUNTS: "manage-accounts",
  DOCUMENT_REQUESTS: "document-requests",
  ADDITIONAL_INFO: "additional-info",
  TRUSTED_CONTACT: "trusted-contact",
  AGREEMENTS: "agreements",
  SECURITY: "security",
  CONNECTED_APPS: "connected-apps",
  CRYPTO_FEES: "crypto-fees",
  IP_ALLOWLIST: "ip-allowlist",
} as const;

export type ProfileTabSlug = (typeof ProfileTabs)[keyof typeof ProfileTabs];

export const PROFILE_TAB_DEFINITIONS: ReadonlyArray<{
  name: string;
  slug: ProfileTabSlug;
}> = [
  { name: "Basic Info", slug: ProfileTabs.BASIC_INFO },
  { name: "Manage Accounts", slug: ProfileTabs.MANAGE_ACCOUNTS },
  { name: "Document Requests", slug: ProfileTabs.DOCUMENT_REQUESTS },
  { name: "Additional Info", slug: ProfileTabs.ADDITIONAL_INFO },
  { name: "Trusted Contact", slug: ProfileTabs.TRUSTED_CONTACT },
  { name: "Agreements", slug: ProfileTabs.AGREEMENTS },
  { name: "Security", slug: ProfileTabs.SECURITY },
  { name: "Connected Apps", slug: ProfileTabs.CONNECTED_APPS },
  { name: "Crypto Fees", slug: ProfileTabs.CRYPTO_FEES },
  { name: "IP Allowlist", slug: ProfileTabs.IP_ALLOWLIST },
];

export const PROFILE_BASE_PATH = "/user/profile";

export const profileTabPath = (slug: ProfileTabSlug) =>
  `${PROFILE_BASE_PATH}#${slug}` as const;

export const parseHash = (hash: string): string => hash.replace(/^#/, "");
